module.exports = __webpack_public_path__ + "img/geofisica3_4-3_1024.48833dac.webp";